/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Connection_UnavailableInputs */

const en_home_v2_connection_unavailable = /** @type {(inputs: Home_V2_Connection_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn’t check connection`)
};

const es_home_v2_connection_unavailable = /** @type {(inputs: Home_V2_Connection_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo comprobar la conexión`)
};

/**
* | output |
* | --- |
* | "Couldn’t check connection" |
*
* @param {Home_V2_Connection_UnavailableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_connection_unavailable = /** @type {((inputs?: Home_V2_Connection_UnavailableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Connection_UnavailableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_connection_unavailable(inputs)
	return en_home_v2_connection_unavailable(inputs)
});